import { request } from '@/shared/api/request'

export const getQuestions = (payload) => {
	return request({ url: 'selftest/get/questions/' + payload, method: 'GET' })
}
